import { getDateString, parseNum, getDateTimeString } from "./bookings-data"
import { getOptions } from "../services/apiService"

export const statusTranslations = {
    open: 'Abierta',
    pending: 'Pendiente de arquear',
    nok: 'Descuadrada',
    closed: 'Cerrada'
}

function dateSort(dta, dtb) {

    return new Date(dta).getTime() - new Date(dtb).getTime()
}

function stringSort(dta, dtb) {

    return new Date(dta).getTime() - new Date(dtb).getTime()
}

export const columnsCashReconciliations = [
    {
        name: 'id',
        field: 'id',
        selector: row => row.id,
        sortable: true,
        width: '50px'
    },
    {
        name: 'Usuario',
        field: 'userId',
        selector: row => row.user?.name ?? row.userId,
        sortable: true,
    },
    {
        name: 'Estado',
        field: 'status',
        selector: row => row.status,
        cell: props => <span className={`cash-reconciliation-status cash-reconciliation-${props.status}`}>{statusTranslations[props.status]}</span>,
        sortable: true,
        width: '170px'
    },
    {
        name: 'Descuadre Efectivo',
        field: 'cashDiscrepancy',
        selector: row => row.cashDiscrepancy,
        cell: row => parseNum('EUR',row.cashDiscrepancy),
        sortable: true,
        width: '150px'
    },
    {
        name: 'Descuadre Tarjeta',
        field: 'cardDiscrepancy',
        selector: row => row.cardDiscrepancy,
        cell: row => parseNum('EUR',row.cardDiscrepancy),
        sortable: true,
        width: '150px'
    },
    {
        name: 'F. Apertura',
        field: 'start',
        selector: row => row.start,
        cell: row => getDateTimeString(row.start),
        width: '120px',
        sortable: true,
    },
    {
        name: 'F. Cierre',
        field: 'end',
        selector: row => row.end,
        cell: row => row.end ? getDateTimeString(row.end) : "Sin cerrar",
        sortable: true,
        width: '120px',
    },
    {
        name: 'Tablao',
        field: 'venueId',
        selector: row => row.venue.name,
        width: '120px',
        sortable: true,
    },
]

export const config = {
    page: 'cashReconciliationsPage',
    localStorageItem: 'cash-reconciliations-filters',
    filtersInterface: {
        venueId: 0,
        userId: [],
        originId: [],
        status: [],
        start: [getDateString(Date.now()), getDateString(Date.now())]
    },
    preferencesInterface: {autoFilters: 0},
    rows: [
        [
            {
                id: 'slct-tablao',
                key: 'venueId',
                type: 'select',
                role: 'filter',
                label: 'Tablao',
                preferences: ['onlyOne', 'autoHide', 'showCurrentValue', 'toggleSelects'],
                optionsAndTags: () => [
                    [
                        { value: 0, name: 'Todos' },
                        { value: 1, name: 'Cardamomo' },
                        { value: 2, name: '1911' },
                    ],
                    [],
                ],
            },

            {
                id: 'slct-state',
                key: 'status',
                role: 'filter',
                type: 'select',
                placeholder: 'Estado',
                preferences: ['selectAllOption', 'showCheckedValuesTag', 'multiSelect', 'toggleSelects'],
                optionsAndTags: async () => [
                    [
                        { value: 'open', name: statusTranslations.open},
                        { value: 'closed', name: statusTranslations.closed },
                        { value: 'nok', name: statusTranslations.nok },
                        { value: 'pending', name: statusTranslations.pending },
                    ],
                    [],
                ],
            },
            {
                id: 'slct-userId',
                key: 'userId',
                type: 'select',
                role: 'filter',
                placeholder: 'Vendedor',
                preferences: ['selectAllOption', 'showCheckedValuesTag', 'multiSelect', 'toggleSelects', 'searchable'],
                optionsAndTags: async () => {
                    let options = await getOptions('userId')
                    if (options.userId===undefined) return [[],[]]
                    return [options.userId.map(({id, name, origins}) => {
                        return { name: `${name} (${id})`, value: id }
                    }),[]]
                }
            },
            {key: 'start', type: 'date', label: 'F. Apertura', role: 'filter'},
        ],
        [
            [{key: 'autoFilters'}], [{key: 'clearFilters'}, {key: 'applyFilters'}]
        ]
    ]
}
